import authInstance from "../Interceptor/interceptor";


export const editProfileEffect = (id,formdata) => {

    return authInstance.put(`/user/updateuser/${id}`,formdata);
  };
  export const ViewProfileEffect = (id) => {
    return authInstance.get(`/user/getuser/${id}`);
};